import { ArrowRight, QrCode, Smartphone, CreditCard } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useTranslation } from "react-i18next";
import { DemoRequestDialog } from "./DemoRequestDialog";
import { useState } from "react";

export function XervenFeatureSection() {
  const { t } = useTranslation();
  const [demoDialogOpen, setDemoDialogOpen] = useState(false);

  const handleDemoClick = () => {
    setDemoDialogOpen(true);
  };

  const features = [
    {
      icon: QrCode,
      title: t("featureSection.features.qrCode.title"),
      description: t("featureSection.features.qrCode.description"),
      color: "bg-blue-500",
    },
    {
      icon: Smartphone,
      title: t("featureSection.features.mobile.title"),
      description: t("featureSection.features.mobile.description"),
      color: "bg-green-500",
    },
    {
      icon: CreditCard,
      title: t("featureSection.features.payments.title"),
      description: t("featureSection.features.payments.description"),
      color: "bg-purple-500",
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-primary/5 to-secondary/5">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-6 animate-fade-in">
            {t("featureSection.title")}{" "}
            <span className="text-primary">
              {t("featureSection.titleHighlight")}
            </span>
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground animate-fade-in animate-delay-300">
            {t("featureSection.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {features.map((feature, index) => (
            <Card
              key={feature.title}
              className="border-0 shadow-lg hover:shadow-xl transition-all duration-500 hover:translate-y-[-8px] animate-fade-in bg-white/50 backdrop-blur-sm"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <CardContent className="p-8 text-center">
                <div
                  className={`w-16 h-16 ${feature.color} rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg`}
                >
                  <feature.icon className="h-8 w-8 text-white" />
                </div>
                <h3 className="text-xl font-semibold mb-4">{feature.title}</h3>
                <p className="text-muted-foreground leading-relaxed">
                  {feature.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center animate-fade-in animate-delay-900">
          <Button size="lg" className="gap-2" onClick={handleDemoClick}>
            {t("featureSection.requestDemo")}
            <ArrowRight className="h-5 w-5" />
          </Button>
        </div>
      </div>

      <DemoRequestDialog
        open={demoDialogOpen}
        onOpenChange={setDemoDialogOpen}
      />
    </section>
  );
}
